import { jsonldYouTube } from './JsonldStore';

export const updateJsonldYouTube = (value) => jsonldYouTube.update((oldValue) => value);
